<div class="container container-e-service-request">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <section
      class="card mb-4"
      [ngClass]="
        submitted && !isInvestorDetailsFormGroupValid()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INVESTOR_DETAILS_TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
        ></app-investor-details>
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-proxy-details>

    <section
      class="card mb-4"
      [ngClass]="
        checkEachBuildingPermitTransferFormControlValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.BUILDING_PERMIT_TRANSFER'
            | translate
        }}
      </div>

      <div class="card-body">
        <label class="text-nowrap" [attr.for]="controlName.PermitTransferDate">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PERMIT_TRANSFER_DATE_TITLE'
              | translate
          }}
        </label>

        <div class="input-group">
          <input
            class="form-control form-control-sm required"
            aria-required="true"
            [attr.placeholder]="'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate"
            [id]="controlName.PermitTransferDate"
            [name]="controlName.PermitTransferDate"
            [formControlName]="controlName.PermitTransferDate"
            ngbDatepicker
            #d="ngbDatepicker"
          />

          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d.toggle()"
            type="button"
          ></button>
        </div>
        @if (
          shouldShowErrorAlert(
            getBuildingPermitTransferDateFormControl(),
            'required'
          )
        ) {
          <div class="alert alert-danger">
            {{ 'FIELD_REQUIRED' | translate }}
          </div>
        }

        <label [attr.for]="controlName.PermitTransferNumber">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PERMIT_TRANSFER_NUMBER_TITLE'
              | translate
          }}
        </label>

        <input
          type="text"
          [name]="controlName.PermitTransferNumber"
          [id]="controlName.PermitTransferNumber"
          class="form-control required mt-2"
          aria-required="true"
          [formControlName]="controlName.PermitTransferNumber"
        />

        @if (
          shouldShowErrorAlert(
            getBuildingPermitTransferNumberFormControl(),
            'required'
          )
        ) {
          <div class="alert alert-danger">
            {{ 'FIELD_REQUIRED' | translate }}
          </div>
        }
      </div>
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkIdentificationConstructionIntentValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.IDENTIFICATION_CONSTRUCTION_INTENT'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-12 my-1">
            <label [attr.for]="controlName.BuildingNameAndType">
              {{
                'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.BUILDING_NAME_AND_TYPE'
                  | translate
              }}
            </label>

            <input
              type="text"
              [name]="controlName.BuildingNameAndType"
              [id]="controlName.BuildingNameAndType"
              class="form-control form-control-sm required"
              aria-required="true"
              [formControlName]="controlName.BuildingNameAndType"
            />

            @if (
              shouldShowErrorAlert(
                getBuildingNameAndTypeFormControl(),
                'required'
              )
            ) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>

        <div class="mb-4">
          <gk-address-form
            [isRequired]="true"
            [form]="formGroup"
            [idPrefix]="'building-permit'"
          ></gk-address-form>
        </div>

        <gk-map
          [mapState]="mapState"
          (dispatch)="handleMapAction($event)"
        ></gk-map>

        <div class="mt-2">
          @if (mapState.mapObjectTablesState[0].mapObjects.length) {
            <gk-map-object-table
              [mapState]="mapState"
              [mapObjectTableStateIndex]="0"
              (dispatch)="handleMapAction($event)"
            ></gk-map-object-table>
          }
        </div>
      </div>

      @if (submitted && !areParcelsChosen()) {
        <div class="card-footer">
          <div class="alert alert-danger mt-2">
            {{
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PARCELS_REQUIRED'
                | translate
            }}
          </div>
        </div>
      }
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkCurrentInvestorDetailsFormGroupValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.CURRENT_INVESTOR_DETAILS_TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getCurrentInvestorDetailsFormGroup()"
          [idPrefix]="'current-investor-details-'"
          [automaticCopyingDataFromPz]="false"
        ></app-investor-details>
      </div>
    </section>

    <gk-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-request-reply-form>

    <section>
      <div class="card border-dark mb-4">
        <div class="card-header text-white bg-dark">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INSTRUCTION'
              | translate
          }}
        </div>

        <div class="card-body">
          <P
            [innerHTML]="
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INSTRUCTION_INFO'
                | translate
            "
          >
          </P>
        </div>
      </div>
    </section>

    <button type="submit" class="btn btn-primary">
      {{
        'ENVIRONMENTAL_PROTECTION_PORTAL.SIMPLIFIED_FOREST_MANAGEMENT_PLAN.FIELDS.SUBMIT_REQUEST'
          | translate
      }}
    </button>

    <app-doc-sign-info
      [messageText]="docSignMsgTxt"
      [messageType]="docSignMsgType"
      [docSignUrl]="docSignUrl"
      [docSignPending]="docSignPending"
    ></app-doc-sign-info>

    <div class="mt-2"><app-form-legend></app-form-legend></div>
  </form>
</div>
